export const CREATE_SELECTABLE_MATERIAL_DIALOG = 'create-selectable-material-dialog';
